"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriesContextProvider = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var server_1 = require("react-dom/server");
var utils_1 = require("../../utils");
var dragAndDrop_1 = require("../../components/lib/dragAndDrop");
var initialState = {
    categories: [],
    can_add_category: false,
};
var CategoriesContext = React.createContext(__assign(__assign({}, initialState), { fetchAll: undefined, onSave: undefined, onCreateCategory: undefined, onCreateTag: undefined, onDeleteCategory: undefined, onChangeMandatoryCategory: undefined, onDeleteTag: undefined, onEditCategory: undefined, onEditTag: undefined, reOrderCategory: undefined, reOrderTag: undefined, onChangeMutuallyExclusive: undefined }));
exports.default = CategoriesContext;
var CategoriesContextProvider = (function (_super) {
    __extends(CategoriesContextProvider, _super);
    function CategoriesContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    CategoriesContextProvider.prototype.getUrl = function () {
        return this.props.is_control_action ?
            urls_1.Urls.admin_ca_categories :
            urls_1.Urls.admin_categories;
    };
    CategoriesContextProvider.prototype.populateDragTypes = function (categories) {
        categories.forEach(function (category) {
            category.type = dragAndDrop_1.DragTypes.ANY;
            category.tags.forEach(function (tag) {
                tag.type = dragAndDrop_1.DragTypes.ANY;
            });
        });
        return categories;
    };
    CategoriesContextProvider.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, $.get((0, urls_1.resolve)(this.getUrl(), this.props.project_id), {}, function (result) {
                        _this.setState({
                            categories: _this.populateDragTypes(result.categories),
                            can_add_category: result.can_add_category,
                        });
                    })];
            });
        });
    };
    CategoriesContextProvider.prototype.onSave = function (force_update) {
        return __awaiter(this, void 0, void 0, function () {
            var self, categories;
            return __generator(this, function (_a) {
                self = this;
                categories = self.state.categories;
                return [2, $.ajax((0, urls_1.resolve)(this.getUrl(), this.props.project_id), {
                        type: "POST",
                        data: JSON.stringify({
                            categories: self.state.categories,
                            force: force_update || false,
                        }),
                        dataType: "json",
                        contentType: "application/json; charset=utf-8"
                    })
                        .fail(function (response) {
                        var data = response.responseJSON;
                        if (data.errors.cause === 'confirmation_needed') {
                            var message = (0, server_1.renderToString)(React.createElement("div", null,
                                React.createElement("div", null, gettext("This change will have the following effects")),
                                React.createElement("ul", null, data.errors.messages.map(function (error_msg) {
                                    return React.createElement("li", null, error_msg);
                                })),
                                React.createElement("div", null, gettext("Are you sure you want to commit these changes?"))));
                            fancyConfirm(message, function () {
                                self.onSave(true);
                            }, undefined, undefined, { collision: "none flip" });
                        }
                        else {
                            data.errors.messages.map(function (error_msg) {
                                notification(error_msg, { type: "error" });
                            });
                        }
                    })
                        .done(function (result) {
                        self.setState({
                            categories: self.populateDragTypes(result.categories),
                        });
                        notification(gettext("Categories and tags were saved successfully"));
                    })];
            });
        });
    };
    CategoriesContextProvider.prototype.onCreateCategory = function () {
        var now = new Date();
        var category = {
            id: 0,
            name: "",
            tags: [],
            editable: true,
            deletable: true,
            canAddTag: true,
            governed: false,
            type: dragAndDrop_1.DragTypes.ANY,
            autofocus: true,
            key: "new-category-".concat(now.getTime()),
            mandatory: false,
            mutuallyExclusive: false,
        };
        this.setState(function (prev) {
            return {
                categories: (prev.categories || []).concat([category])
            };
        });
    };
    CategoriesContextProvider.prototype.onCreateTag = function (category) {
        var now = new Date();
        var tag = {
            id: 0,
            name: "",
            editable: true,
            deletable: true,
            type: dragAndDrop_1.DragTypes.ANY,
            autofocus: true,
            key: "new-tag-".concat(now.getTime()),
        };
        category.tags.push(tag);
        this.setState(function (prev) {
            var index = prev.categories.indexOf(category);
            prev.categories.splice(index, 1, category);
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onDeleteCategory = function (category) {
        this.setState(function (prev) {
            var index = prev.categories.indexOf(category);
            prev.categories.splice(index, 1);
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onChangeMandatoryCategory = function (mandatory, category) {
        this.setState(function (prev) {
            category.mandatory = mandatory;
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onChangeMutuallyExclusive = function (mutuallyExclusive, category) {
        this.setState(function (prev) {
            category.mutuallyExclusive = mutuallyExclusive;
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onDeleteTag = function (category, tag) {
        var tagIndex = category.tags.indexOf(tag);
        category.tags.splice(tagIndex, 1);
        this.setState(function (prev) {
            var index = prev.categories.indexOf(category);
            prev.categories.splice(index, 1, category);
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onEditCategory = function (name, category) {
        this.setState(function (prev) {
            var index = prev.categories.indexOf(category);
            category.name = name;
            category.autofocus = false;
            prev.categories.splice(index, 1, category);
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.onEditTag = function (name, category, tag) {
        var tagIndex = category.tags.indexOf(tag);
        tag.name = name;
        tag.autofocus = false;
        category.tags.splice(tagIndex, 1, tag);
        this.setState(function (prev) {
            var index = prev.categories.indexOf(category);
            prev.categories.splice(index, 1, category);
            return {
                categories: prev.categories
            };
        });
    };
    CategoriesContextProvider.prototype.reOrderCategory = function (previousIndex, nextIndex) {
        this.setState(function (prev) {
            return {
                categories: (0, utils_1.arrayMoveClone)(prev.categories, previousIndex, nextIndex)
            };
        });
    };
    CategoriesContextProvider.prototype.reOrderTag = function (category, previousIndex, nextIndex) {
        this.setState(function (prev) {
            category.tags = (0, utils_1.arrayMoveClone)(category.tags, previousIndex, nextIndex);
            var nextCategories = prev.categories;
            var index = nextCategories.indexOf(category);
            nextCategories.splice(index, 1, category);
            return {
                categories: nextCategories
            };
        });
    };
    CategoriesContextProvider.prototype.render = function () {
        return (React.createElement(CategoriesContext.Provider, { value: __assign(__assign({}, this.state), { fetchAll: this.fetchAll.bind(this), onSave: this.onSave.bind(this), onCreateCategory: this.onCreateCategory.bind(this), onCreateTag: this.onCreateTag.bind(this), onDeleteCategory: this.onDeleteCategory.bind(this), onChangeMandatoryCategory: this.onChangeMandatoryCategory.bind(this), onDeleteTag: this.onDeleteTag.bind(this), onEditCategory: this.onEditCategory.bind(this), onEditTag: this.onEditTag.bind(this), reOrderCategory: this.reOrderCategory.bind(this), reOrderTag: this.reOrderTag.bind(this), onChangeMutuallyExclusive: this.onChangeMutuallyExclusive.bind(this) }) }, this.props.children));
    };
    return CategoriesContextProvider;
}(React.Component));
exports.CategoriesContextProvider = CategoriesContextProvider;
